import { Actor } from "@inrev/common";
import { z } from "zod";

export const SignalActorSchema = z.discriminatedUnion("type", [
	z.object({
		type: z.enum(["admin_user", "agent_user"]),
		id: z.string(),
		name: z.string(),
	}),
	z.object({
		type: z.enum(["system", "vendor"]),
		name: z.string(),
	}),
]);

export type SignalActor = z.infer<typeof SignalActorSchema>;

const BaseSignalSchema = z.object({
	id: z.templateLiteral([z.number().int(), "-", z.uuid()]),
	actor: SignalActorSchema,
	agencyId: z.string().optional(),
	timestamp: z.number(),
});

export const SignalSchema = z.discriminatedUnion("type", [
	BaseSignalSchema.extend({
		type: z.literal("invalidate"),
		queryKeys: z.array(z.array(z.string())),
		message: z.string().optional(),
	}),
	BaseSignalSchema.extend({
		type: z.literal("notify"),
		message: z.string(),
		level: z.enum(["info", "success", "warning", "error"]),
	}),
]);

export type Signal = z.infer<typeof SignalSchema>;

// biome-ignore lint/suspicious/noExplicitAny: legacy any
type DistributiveOmit<T, K extends keyof any> = T extends unknown ? Omit<T, K> : never;
export type SignalPayload = DistributiveOmit<Signal, "id" | "timestamp">;

export function toSignalActor(actor: Actor): SignalActor {
	switch (actor.type) {
		case "admin_user":
		case "agent_user":
			return { type: actor.type, id: actor.user.id, name: actor.user.fullName ?? actor.user.email };
		case "system":
			return { type: "system", name: actor.source };
		case "vendor":
			return { type: "vendor", name: actor.source };
	}
}
